module.exports = __webpack_public_path__ + "static/img/swiper1.912b085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swiper1.png
// module id = uczZ
// module chunks = 0